import React from 'react';
import $ from 'jquery';
import {TweenMax} from "gsap";
import ScrollMagic from 'scrollmagic'

class Banner extends React.Component {
        render() {
          return (
          	<section className="team about-team">
			  <div className="teaminner2">
			    <div className="teaminner">
			      <div className="teaminnermain">
			        <div className="container">
			          <div className="row">
			            <div className="col-md-7 breeserif titletext">
			              <h1 className="breeserif titletext">Services<br />&nbsp;</h1>
			            </div>
			            <div className="col-md-5 visible-lg"><img src="images/MVP-Hero-Circle-2.png" alt="" className="img-responsive center-block" /></div>
			          </div>
			        </div>
			      </div>
			    </div>
			  </div>
			</section>
          );
        }
}

class MainContent extends React.Component {
		componentDidMount() {
				var controller = new ScrollMagic.Controller();

var scene = new ScrollMagic.Scene({
									triggerElement: ".infobox-video"
								})
								.setTween(".services-section.one h1", .8, {opacity:1, left:0}) // trigger a TweenMax.to tween
								.addTo(controller);
								
var scene = new ScrollMagic.Scene({
									triggerElement: ".infobox-video"
								})
								.setTween(".services-section.one p.font24", .8, {delay:.3, opacity:1, left:0}) // trigger a TweenMax.to tween
								.addTo(controller);
var scene = new ScrollMagic.Scene({
									triggerElement: ".infobox-video"
								})
								.setTween(".services-section.one p.font21", .8, {delay:.7, opacity:1, left:0}) // trigger a TweenMax.to tween
								.addTo(controller);	
								
var scene = new ScrollMagic.Scene({
									triggerElement: ".infobox-video"
								})
								.setTween(".services-section.one p.font29", .8, {delay:.9, opacity:1, left:0}) // trigger a TweenMax.to tween
								.addTo(controller);								
	
/**********************************************************************/

var scene = new ScrollMagic.Scene({
									triggerElement: ".services-section.two"
								})
								.setTween(".services-section.two h1", .8, {opacity:1, right:0}) // trigger a TweenMax.to tween
								.addTo(controller);
								
var scene = new ScrollMagic.Scene({
									triggerElement: ".services-section.two"
								})
								.setTween(".services-section.two p.font24", .8, {delay:.3, opacity:1, right:0}) // trigger a TweenMax.to tween
								.addTo(controller);
var scene = new ScrollMagic.Scene({
									triggerElement: ".services-section.two"
								})
								.setTween(".services-section.two p.font21", .8, {delay:.7, opacity:1, right:0}) // trigger a TweenMax.to tween
								.addTo(controller);	
var scene = new ScrollMagic.Scene({
									triggerElement: ".services-section.two"
								})
								.setTween(".services-section.two p.font29", .8, {delay:.9, opacity:1, right:0}) // trigger a TweenMax.to tween
								.addTo(controller);																								
	
/**********************************************************************/	
var scene = new ScrollMagic.Scene({
									triggerElement: ".services-section.three"
								})
								.setTween(".services-section.three h1", .8, {opacity:1, left:0}) // trigger a TweenMax.to tween
								.addTo(controller);
								
var scene = new ScrollMagic.Scene({
									triggerElement: ".services-section.three"
								})
								.setTween(".services-section.three p.font24", .8, {delay:.3, opacity:1, left:0}) // trigger a TweenMax.to tween
								.addTo(controller);
var scene = new ScrollMagic.Scene({
									triggerElement: ".services-section.three"
								})
								.setTween(".services-section.three p.font21", .8, {delay:.7, opacity:1, left:0}) // trigger a TweenMax.to tween
								.addTo(controller);
var scene = new ScrollMagic.Scene({
									triggerElement: ".services-section.three"
								})
								.setTween(".services-section.three p.font29", .8, {delay:.9, opacity:1, left:0}) // trigger a TweenMax.to tween
								.addTo(controller);																
	
/**********************************************************************/
var scene = new ScrollMagic.Scene({
									triggerElement: ".services-section.four"
								})
								.setTween(".services-section.four h1", .8, {opacity:1, right:0}) // trigger a TweenMax.to tween
								.addTo(controller);
								
var scene = new ScrollMagic.Scene({
									triggerElement: ".services-section.four"
								})
								.setTween(".services-section.four p.font24", .8, {delay:.3, opacity:1, right:0}) // trigger a TweenMax.to tween
								.addTo(controller);
var scene = new ScrollMagic.Scene({
									triggerElement: ".services-section.four"
								})
								.setTween(".services-section.four p.font21", .8, {delay:.7, opacity:1, right:0}) // trigger a TweenMax.to tween
								.addTo(controller);	
var scene = new ScrollMagic.Scene({
									triggerElement: ".services-section.four"
								})
								.setTween(".services-section.four p.font29", .8, {delay:.9, opacity:1, right:0}) // trigger a TweenMax.to tween
								.addTo(controller);																
	
/**********************************************************************/
var scene = new ScrollMagic.Scene({
									triggerElement: ".services-section.five"
								})
								.setTween(".services-section.five h1", .8, {opacity:1, left:0}) // trigger a TweenMax.to tween
								.addTo(controller);
								
var scene = new ScrollMagic.Scene({
									triggerElement: ".services-section.five"
								})
								.setTween(".services-section.five p.font24", .8, {delay:.3, opacity:1, left:0}) // trigger a TweenMax.to tween
								.addTo(controller);
var scene = new ScrollMagic.Scene({
									triggerElement: ".services-section.five"
								})
								.setTween(".services-section.five p.font21", .8, {delay:.7, opacity:1, left:0}) // trigger a TweenMax.to tween
								.addTo(controller);	
var scene = new ScrollMagic.Scene({
									triggerElement: ".services-section.five"
								})
								.setTween(".services-section.five p.font29", .8, {delay:.9, opacity:1, left:0}) // trigger a TweenMax.to tween
								.addTo(controller);																
	
/**********************************************************************/
var scene = new ScrollMagic.Scene({
									triggerElement: ".services-section.six"
								})
								.setTween(".services-section.six h1", .8, {opacity:1, right:0}) // trigger a TweenMax.to tween
								.addTo(controller);
								
var scene = new ScrollMagic.Scene({
									triggerElement: ".services-section.six"
								})
								.setTween(".services-section.six p.font24", .8, {delay:.3, opacity:1, right:0}) // trigger a TweenMax.to tween
								.addTo(controller);
var scene = new ScrollMagic.Scene({
									triggerElement: ".services-section.six"
								})
								.setTween(".services-section.six p.font21", .8, {delay:.7, opacity:1, right:0}) // trigger a TweenMax.to tween
								.addTo(controller);
								
var scene = new ScrollMagic.Scene({
									triggerElement: ".services-section.six"
								})
								.setTween(".services-section.six li.font29", .8, {delay:.9, opacity:1, right:0}) // trigger a TweenMax.to tween
								.addTo(controller);	
								
var scene = new ScrollMagic.Scene({
									triggerElement: ".services-section.six"
								})
								.setTween(".services-section.six li.font29.item2", .8, {delay:1.2, opacity:1, right:0}) // trigger a TweenMax.to tween
								.addTo(controller);	
var scene = new ScrollMagic.Scene({
									triggerElement: ".services-section.six"
								})
								.setTween(".services-section.six li.font29.item3", .8, {delay:1.4, opacity:1, right:0}) // trigger a TweenMax.to tween
								.addTo(controller);	
var scene = new ScrollMagic.Scene({
									triggerElement: ".services-section.six"
								})
								.setTween(".services-section.six li.font29.item4", .8, {delay:1.6, opacity:1, right:0}) // trigger a TweenMax.to tween
								.addTo(controller);	
var scene = new ScrollMagic.Scene({
									triggerElement: ".services-section.six"
								})
								.setTween(".services-section.six li.font29.item5", .8, {delay:1.8, opacity:1, right:0}) // trigger a TweenMax.to tween
								.addTo(controller);																																																
var scene = new ScrollMagic.Scene({
									triggerElement: ".services-section.six"
								})
								.setTween(".services-section.six li.font29.item6", .8, {delay:2.0, opacity:1, right:0}) // trigger a TweenMax.to tween
								.addTo(controller);																																																
var scene = new ScrollMagic.Scene({
									triggerElement: ".services-section.six"
								})
								.setTween(".services-section.six li.font29.item7", .8, {delay:2.2, opacity:1, right:0}) // trigger a TweenMax.to tween
								.addTo(controller);																																																
var scene = new ScrollMagic.Scene({
									triggerElement: ".services-section.six"
								})
								.setTween(".services-section.six li.font29.item8", .8, {delay:2.4, opacity:1, right:0}) // trigger a TweenMax.to tween
								.addTo(controller);																																																
var scene = new ScrollMagic.Scene({
									triggerElement: ".services-section.six"
								})
								.setTween(".services-section.six li.font29.item9", .8, {delay:2.6, opacity:1, right:0}) // trigger a TweenMax.to tween
								.addTo(controller);																																																
var scene = new ScrollMagic.Scene({
									triggerElement: ".services-section.six"
								})
								.setTween(".services-section.six li.font29.item10", .8, {delay:2.8, opacity:1, right:0}) // trigger a TweenMax.to tween
								.addTo(controller);																																																
var scene = new ScrollMagic.Scene({
									triggerElement: ".services-section.six"
								})
								.setTween(".services-section.six li.font29.item11", .8, {delay:3.0, opacity:1, right:0}) // trigger a TweenMax.to tween
								.addTo(controller);	

		function getQueryStringValue (key) {  
  			return decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));  
		}
		var target = "#" + getQueryStringValue('section');
		$("html, body").animate({ scrollTop: $(target).offset().top }, 1000);
	
		}
        render() {
          return (
          	<div>
          		<div className="container">
				  <div className="infobox-video">
				    <div className="row pad-top-40">
				      <div className="col-sm-12">
				        <h1><span className="video-bg">We Go the Extra Mile</span></h1>
				    <br />&nbsp;
				      </div>
				    </div>
				  </div>
				</div>

				<div className="container">
				<section className="services-section services-temp one" id="services-temporary-staffing">
				    <div className="row pad-20">
				      <div className="col-sm-12 text-center">
					  <div className="col-sm-1"></div>
				      <div className="col-sm-5 pad-20">
				          <h1 className="breeserif">Temporary Staffing</h1>
				          <p className="flamaitalic font24 pad-bot-20">You need to have an operation that runs smoothly – no matter what.</p>
						  <p className="flamalight font21">MVP can help you do just that by providing qualified, pre-screened workers in the numbers you need. We’re always recruiting and when we find potential, we systematically vet each candidate. The result is people you can trust and depend on.</p>
						  <p className="flamalight font29">Whether the assignment is one day or one year, our scalable solution ensures your goals are accomplished with qualified, safety-aware individuals hand-picked by our local market experts. With our breadth of quality candidates, we can accommodate needs of any size. In many cases, entire staffs are made up of MVP employees.</p>
				      </div>
				    </div>
				  </div>
				</section>
				</div>

				<div className="container">
				<section className="services-section services-temp-to-perm two" id="services-temporary-to-permanent">
				    <div className="row pad-20">
				       <div className="col-sm-12 text-center">
					     <div className="col-sm-6"></div>
				           <div className="col-sm-5 pad-20">
				             <h1 className="breeserif">Temporary-to-Permanent</h1>
				             <p className="flamaitalic font24 pad-bot-20">With semi-skilled or skilled positions, you’re making a more substantial investment.</p>
				             <p className="flamalight font21">Just like you wouldn’t buy a house without inspecting it, we don’t expect you to hire a candidate without having complete confidence in a successful future. Taking a candidate through a practice run is a great way to hedge your bets.</p>
							 <p className="flamalight font29">With a Temp-to-Perm placement, we do the recruiting and you get a risk-free opportunity to see if the candidate is a good fit for your business. Each candidate is screened with the work details and goals in mind, ensuring they are properly suited for the task at hand.</p>
						   </div>
					  <div className="col-sm-1"></div>
				      </div>
				    </div>
				</section>
				</div>

				<div className="container">
				<section className="services-section services-direct three" id="services-direct-hire">
					<div className="row pad-20">
						<div className="col-sm-12 text-center">
					  <div className="col-sm-1"></div>
				      <div className="col-sm-5 pad-20">
							<h1 className="breeserif">Direct Hire</h1>
							<p className="flamaitalic font24 pad-bot-20">Recruitment and hiring can drain valuable time and financial resources. On your own, thoroughly evaluating a list of candidates can be an exhaustive effort before finding the right match.</p>
							<p className="flamalight font21">We are experienced recruitment specialists, with extensive reach into the candidate pools of many types of jobs and industries. Our relationships will save you time, money and frustrations. We will do all the legwork to help you find the right employee.</p>
						</div>
					  </div>
					</div>
				</section>
				</div>

				<div className="container">
				<section className="services-section services-onsite four" id="services-onsight-solutions">
				    <div className="row pad-20">
				       <div className="col-sm-12 text-center">
					  <div className="col-sm-6"></div>
				      <div className="col-sm-5 pad-20">
				          <h1 className="breeserif">Onsite Programs</h1>
				          <p className="flamaitalic font24 pad-bot-20">MVP is responsible for our employees who work on your team.</p>
				          <p className="flamalight font21">We provide all administration, which includes managing day-to-day issues as well as payroll services. Beyond this, you have the option of having an on-site manager who directly supervises the employees, monitoring performance and modifying schedules and assignments as necessary.</p>
						  <p className="flamalight font29">Who knows our employees better than our own managers? We’re here to help drive your business forward by building a talented and effective work force and guiding it to meet your business goals.</p>
				      </div>
				    </div>
				  </div>
				</section>
				</div>

				<div className="container">
				<section className="services-section services-hr five" id="services-hr-back-office-solutions">
				  <div className="row pad-20">
				 	<div className="col-sm-12 text-center">
					  <div className="col-sm-1"></div>
				      <div className="col-sm-5 pad-20">
				        <h1 className="breeserif">Human Resources and Back-Office Solution</h1>
				        <p className="flamaitalic font24 pad-bot-20">For small and mid-size businesses, HR and back-office duties can be a substantial drain on resources.</p>
				        <p className="flamalight font21">With our extensive experience in recruiting, employee benefits, workers’ compensation insurance and payroll, we offer businesses a one-stop shop for HR functions. Our staff averages more than 16 years of experience, positioning us to provide these capabilities to your business.</p>
						<p className="flamalight font29">Business owners are focused day-to-day operations. Administrative responsibilities sometimes are an afterthought. Relieving your organization of HR and back-office duties free up time and money than can be redirected into strategic growth.</p>
				      </div>
				    </div>
				  </div>
				</section>
				</div>

				<div className="container">
				<section className="services-section services-managed six" id="services-managed-services">
				  <div className="row">
				    <div className="col-sm-12 text-center">
					  <div className="col-sm-6"></div>
				      <div className="col-sm-5 pad-20">
				        <h1 className="breeserif">Managed Serivces</h1>
				        <p className="flamaitalic font24 pad-bot-20">Having MVP as your managed services provider allows you to focus on growing your business and gaining a competitive edge.</p>
				        <p className="flamalight font21">You manage your opportunities. We’ll manage everything else. MVP Managed Services offers a turnkey suite of staff management services that erases complexity and hassles and promotes a seamless business.</p>
						<div>
							<ul className="col-md-6">
								<li className="flamalight font29 ">Worker’s Compensation Insurance </li>
								<li className="flamalight font29 ">ACA Administration/ Compliance </li>
								<li className="flamalight font29 ">HR Front-and-Back Office Technology </li>
								<li className="flamalight font29 ">Complete Payroll Services </li>
								<li className="flamalight font29 ">Simplified Rate Structure, including Worker’s Compensation </li>
							</ul>
							<ul className="col-md-6">			
								<li className="flamalight font29 ">Risk Management Consulting and Support </li>
								<li className="flamalight font29 ">Taxes and Unemployment </li>
								<li className="flamalight font29 ">Direct Deposit and Check Cards </li>
								<li className="flamalight font29 ">Financial Reporting </li>
								<li className="flamalight font29 ">Assumption of all Legal Risk </li>
								<li className="flamalight font29 ">I-9 Processing and Compliance</li>
							</ul>
						</div>
				      </div>
				    </div>
				  </div>
				</section>
				</div>

          	</div>
          );
        }
}






function Service() {
  return (
  <div>
      <Banner />
      <MainContent />
  </div>    
  );
}

export default Service


// WEBPACK FOOTER //
// ./src/services.js